import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fiinzo-header',
  templateUrl: './fiinzo-header.component.html',
  styleUrls: ['./fiinzo-header.component.scss']
})
export class FiinzoHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
